import Kiemtra from "./danhba/Kiemtra";
import Danhba34tinh from "./danhba/Danhba34tinh";
import Accordion from "./danhba/temp";
import MyComponent from "./danhba/temp1";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";

const App = () => {

  return (
     <>
      <BrowserRouter>
        <Link to="/"></Link>
        <Link to="/db34tinh"></Link>
        <Routes>
          <Route path="/" element={<Kiemtra/>}/>
          <Route path="/db34tinh" element={<Danhba34tinh />}/>
          <Route path="/temp" element={<Accordion />}/>
          <Route path="/temp1" element={<MyComponent />}/>
        </Routes>
      </BrowserRouter>
    </>
  )
}
export default App;